<div class="row" style="margin-bottom:20px;padding:5px;">
  <div class="col-md-2" style="padding:0px;margin:0px;">
    <img class="img-hgt" src="/assets/logo.png" alt="iCBMS" style="width:100%;padding:0px 2px 1px 0px;margin:0px 2px 1px 0px;">
  </div>
  <div class="col-md-10 mn-hgt" style="padding:0px;margin:0px;">
    <div class="col-md-12" style="padding:0px;margin:0px;">
      <div class="col-md-12 pb-md-4 pb-xs-4 pb-xl-0 h-6 lead-font-size text-black d-flex align-items-center" style="margin-top: 2px;padding:0px;">
        <p style="margin:0px; padding:0px;">
          <strong>Contact us:</strong> +27 (0)12 471 2121 <strong> | </strong><a href="mailto:customercare@cbrta.co.za" class="must-clr">customercare@cbrta.co.za</a> <br />Mondays 9am to 4pm; Tuesdays to Fridays 7:30am to 4pm.
        </p>
      </div>
    </div>
    <div class="col-md-12 mn-hgt" style="padding:0px;margin:0px;color:yellow!important;">
      <nav class="nav navbar  bg-gray py-sm-3 mn-hgt"  style="padding:0px;margin:0px;height:52px!important;color:yellow!important;">
        <ul class="nav navbar pos-x mn-hgt" style="color:yellow!important;">
          <li class="navbar-brand pos-x"><a class="must-clr" routerLink="" style="color:rgb(253, 207,76 ); padding-left: 2px;;">iCBMS</a></li>
          <!-- <li class="nav-link pos-x"><a style="color:rgb(253, 207,76 );" routerLink="">Home</a></li>           -->
          <li class="dropdown" *ngFor="let mm of authentication.userData?.MainMenus"
              [style.display]="authentication.authenticated && subMenus(mm).length ? 'block' : 'none'">
            <a style="color:rgb(253, 207,76 );" class="h-4 nav-link" data-toggle="dropdown" role="button" aria-haspopup="true"
               aria-expanded="false">{{mm.Name}}<span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li *ngIf="mm.Code=='ADMIN'">
                <a class="dropdown-item" href="javascript:void(0);" (click)="navAuthWeb()"
                   style="color:rgb(253, 207,76 );">Auth-Web</a>
              </li>
              <li *ngIf="mm.Code=='ADMIN'">
                <a class="dropdown-item" href="javascript:void(0);" (click)="navSharePoint()"
                   style="color:rgb(253, 207,76 );">SharePoint Site</a>
              </li>
              <li *ngFor="let sm of subMenus(mm)">
                <a class="dropdown-item pos-x" style="color:rgb(253, 207,76 );"
                   [routerLink]="[pathFromScreenName(sm.ScreenName)]"
                   [queryParams]="queryParamsFromScreenName(sm.ScreenName)">{{sm.Name}}</a>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="nav navbar-right ul-brd pos-x">
          <li class="dropdown pos-x" style="padding:0px;margin:0px;">
            <a *ngIf="!authentication.authenticated" class="item-color">
              <table border="0" cellpadding="0" cellspacing="0" style="border:0;margin:0;padding:0">
                <tr>
                  <td>
                    <a style="cursor:pointer;color:rgb(253, 207,76 );" class="item-color" [routerLink]="['/login']">
                      <i class="fa fa-sign-in"></i>&nbsp;Login
                    </a>
                  </td>
                  <td style="padding-left:20px">
                    <a style="cursor:pointer;color:rgb(253, 207,76 );" class="item-color"
                       [routerLink]="['/register']"><i class="fa fa-user-plus" aria-hidden="true"></i>&nbsp;Create User Profile</a>
                  </td>
                </tr>
              </table>
            </a>
            <a *ngIf="authentication.authenticated" href="#" class="dropdown-toggle item-color" data-toggle="dropdown"
               role="button" aria-haspopup="true" aria-expanded="false" style="color:rgb(253, 207,76 );">
              <i class="fa fa-user" aria-hidden="true"></i> {{authentication.userData?.User?.FirstName}} {{authentication.userData?.User?.LastName}} <span class="caret"></span>
            </a>
            <ul *ngIf="authentication.authenticated" class="dropdown-menu dropdown-menu-right">
              <li>
                <a class="dropdown-item" style="cursor:pointer;color:rgb(253, 207,76 );"  [routerLink]="['/ammenduser']">
                  <i class="fa fa-address-card" aria-hidden="true"></i>&nbsp;Profile
                </a>
              </li>
              <li>
                <a class="dropdown-item" style="cursor:pointer;color:rgb(253, 207,76 );"  [routerLink]="['/reset']">
                  <i class="fa fa-user-secret" aria-hidden="true"></i>&nbsp;Reset Password
                </a>
              </li>
              <li>
                <a class="dropdown-item" style="cursor:pointer;color:rgb(253, 207,76 );"  (click)="authentication.logout()">
                  <i class="fa fa-sign-out"
                     aria-hidden="true"></i>&nbsp;Logout
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
